(function (app) {

    app.constant("_relationshipTypes",
        [
            { ShortName: "Owner", LongName: "Owner" },
            { ShortName: "JointOwner", LongName: "Joint Owner" },
            { ShortName: "Annuitant", LongName: "Annuitant" },
            { ShortName: "JointAnnuitant", LongName: "Joint Annuitant" },
            { ShortName: "Insured", LongName: "Insured" },
            { ShortName: "JointInsured", LongName: "Joint Insured" },
            { ShortName: "Beneficiary", LongName: "Beneficiary" },
            { ShortName: "ContingentBeneficiary", LongName: "Contingent Beneficiary" }
        ]);

})(window.app); //jshint ignore:line